<template>
	<v-toolbar app fixed :clipped-left="$vuetify.breakpoint.lgAndUp" clipped-right color="primary" flat dense>
		<v-toolbar-side-icon @click="toggleNavPane" />
		<div class="ml-3 hidden-sm-and-down">
			<router-link class="d-inline-block logo" :to="{ name: 'action-list', params: { filter: 'all' } }">
				<img src="@/assets/logo.png" height="32"/>
			</router-link>
		</div>

		<v-spacer />

		<v-text-field
			ref="searchfield"
			class="searchfield"
			height="32px"
			:solo-inverted="!searching"
			:solo="searching"
			:dark="!searching"
			flat hide-details clearable
			prepend-inner-icon="mdi-magnify"
			:label="$t('SEARCH_HINT')"
			:value="query"
			@change="refreshSearch"
			@click:clear="clearSearch"
			@click:prepend-inner="runSearch" />

		<v-spacer />

		<dialog-debug v-if="debugMode" />
		<lang-picker />
		<v-tooltip bottom>
			<template #activator="data">
				<v-btn icon v-on="data.on" @click="logout"><v-icon>mdi-power</v-icon></v-btn>
			</template>
			<span>{{ $t('LOGOUT_TEXT') }}</span>
		</v-tooltip>
	</v-toolbar>
</template>


<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { toRouteParams } from '@/utils/helpers';
import DialogDebug from '@/dialogs/DialogDebug';
import LangPicker from './LangPicker';

export default {
	name: "top-bar",
	components: { DialogDebug, LangPicker },
	computed: {
		...mapState(['toolbarIconColor', 'toolbarIconSize', 'debugMode']),
		...mapGetters('search', ['query']),
		searching() { return !!this.query },
	},
	methods: {
		...mapActions(['toggleNavPane']),
		logout() {
			this.$store.dispatch('auth/logout');
			this.$store.dispatch('unloadAppData');
		},

		runSearch() {
			if (!this.searching) {
				this.$refs['searchfield'].focus();
			}
		},
		async refreshSearch(value) {
			if (!value) { this.clearSearch() }
			else {
				const filter = toRouteParams({ type: 'search', value });
				this.$router.push({ name: 'action-list', params: { filter } });
			}
		},
		clearSearch() {
			this.$store.commit('search/setQuery', null);
		},
	},
};
</script>

<style lang="less">
	.logo img {
		vertical-align: middle;
	}

	.searchfield.v-text-field.v-text-field--solo {
		.v-input__control {
			min-height: 32px !important;
		}
	}
</style>
